import { ImgHTMLAttributes } from 'react'
import { directusBackgroundImage } from '@/src/components/common/DirectusImage'

export function NoImg() {
  return (
    <Img
      src={'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='}
      style={{
        ...directusBackgroundImage(),
        minHeight: 24,
        minWidth: 24,
      }}
    />
  )
}

export default function Img(_: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    /* eslint-disable-next-line @next/next/no-img-element */
    <img
      {..._}
      className={_.className}
      src={_.src}
      alt={_.alt ?? ''}
      loading={_.loading ?? 'lazy'}
    />
  )
}
